<template>
  <q-dialog :visible="visible" title="销售状态" width="500px" :innerScroll="false" @close="handleClose">
    <el-form size="mini" ref="formRef" :model="form" :rules="rules" label-width="100px" v-loading="loading">
      <el-form-item label="销售状态:" prop="saleStatusNew">
        <el-select v-model="form.saleStatusNew" placeholder="请选择销售状态">
          <el-option v-for="item in saleStatusList" :value="item.saleStatus" :label="item.saleStatus" :key="item.saleStatus"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose" size="medium">取消</el-button>
      <el-button type="primary" @click="handleConfirm" size="medium" :loading="submitLoading">确定</el-button>
      <el-button
        type="success"
        @click="handleNotifyOpen"
        size="small"
        :loading="submitLoading"
        v-permission="'ec-pc-new#salespriceIndex#noticeBtn'"
        >确定并通知店铺</el-button
      >
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'SaleStatusDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    saleStatusList: {
      type: Array,
      default: () => [],
    },
    searchFormData: {
      type: Object,
      default: () => ({}),
    },
    saleStatusBeforeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      form: {
        saleStatusNew: '',
      },
      rules: {
        saleStatusNew: [{ required: true, message: '请选择销售状态', trigger: 'change' }],
      },
      isNotify: false,
      notifyForm: {},
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.saleStatusNew = '';
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.clearValidate();
        });
      }
    },
  },
  methods: {
    handleClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleNotifyOpen() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.$emit('notify-open');
      });
    },
    handleNotifyConfirm(data) {
      this.isNotify = true;
      this.notifyForm = data;
      this.submitForm();
    },
    handleConfirm() {
      this.isNotify = false;
      this.submitForm();
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        let data = {
          ...this.searchFormData,
          ...this.form,
        };
        this.$q.goods
          .saleStatusUpdate({ data: data })
          .then((res) => {
            if (res.success) {
              this.$message.success('调整成功');
              if (this.isNotify) {
                this.notifyStore();
              } else {
                let notiyData = {
                  adjustContent: '销售状态',
                  isImport: 0,
                  operType: '不通知',
                };
                this.notificationLog(notiyData);
              }
              this.$emit('success');
              this.handleClose();
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    notifyStore() {
      let itemAOList = this.saleStatusBeforeList.map((v) => {
        return {
          skuCode: v.goodsCode,
          adjustBefore: v.saleStatus,
          adjustAfter: this.form.saleStatusNew,
        };
      });
      let data = {
        ...this.notifyForm,
        adjustContent: '销售状态',
        itemAOList: itemAOList,
        isImport: 0,
        operType: '通知',
      };
      this.notificationLog(data);
      this.$q.goods.saveMsgNotice({ data: data }).then((res) => {
        if (res.success) {
          if (this.notifyForm.noticeTime == 0) {
            this.$store.dispatch('menu/getMenusNum', {}, { root: true });
          }
        }
      });
    },
    notificationLog(data) {
      this.$q.goods.msgNoticeSaveLog({ data: data });
    },
    setLoading(val) {
      this.loading = val;
    },
  },
};
</script>
